var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _path, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestoClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 184 138",
    style: {
      enableBackground: "new 0 0 184 138"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F5F4F3;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#F95111;}\r\n\t.st3{fill:#AB947D;}\r\n\t.st4{fill:#C0AF9F;}\r\n\t.st5{fill:#463527;}\r\n\t.st6{opacity:0.2;}\r\n\t.st7{fill:#8C7A67;}\r\n\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill:#F5F4F3;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127,113c-11.1,44.1-79,12.7-94-2s-50.4-51.2-7.8-64C67.8,34.3,48.6,15,92.2,9.5S157.7,12.2,179,49 S138.1,68.9,127,113z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M112,85.7c0,2.4-1.9,4.3-4.3,4.3H66.3c-2.4,0-4.3-1.9-4.3-4.3V64.1c0-2.4,1.9-4.3,4.3-4.3h41.3 c2.4,0,4.3,1.9,4.3,4.3V85.7z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 159,
    cy: 111,
    r: 14
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 11.5,
    cy: 27.5,
    r: 8.5
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 68.7,
    cy: 83.3,
    r: 2.5
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 68.7,
    cy: 66.5,
    r: 2.5
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 105.3,
    cy: 83.3,
    r: 2.5
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 105.3,
    cy: 66.5,
    r: 2.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M94.2,80.7l-5.6-5.6l5.3-5.2c0.5-0.5,0.5-1.3,0-1.8c-0.5-0.5-1.3-0.5-1.8,0l-5.3,5.3l-5.3-5.3 c-0.5-0.5-1.3-0.5-1.8,0c-0.5,0.5-0.5,1.3,0,1.8l5.3,5.2l-5.6,5.6c-0.5,0.5-0.5,1.3,0,1.8c0.2,0.2,0.6,0.4,0.9,0.4 c0.3,0,0.6-0.1,0.9-0.4l5.6-5.6l5.6,5.6c0.2,0.2,0.6,0.4,0.9,0.4c0.3,0,0.6-0.1,0.9-0.4C94.7,82,94.7,81.2,94.2,80.7z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M7.4,86.6c-0.3-0.3-0.8-0.3-1.1,0L4,88.9l-2.2-2.2c-0.3-0.3-0.8-0.3-1.1,0c-0.3,0.3-0.3,0.8,0,1.1L2.9,90 l-2.2,2.2c-0.3,0.3-0.3,0.8,0,1.1c0.2,0.2,0.4,0.2,0.6,0.2s0.4-0.1,0.6-0.2L4,91.1l2.2,2.2c0.2,0.2,0.4,0.2,0.6,0.2 s0.4-0.1,0.6-0.2c0.3-0.3,0.3-0.8,0-1.1L5.1,90l2.2-2.2C7.7,87.5,7.7,86.9,7.4,86.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M115.9,17.6l-2.9,1.3l-1.3-2.9c-0.2-0.4-0.7-0.6-1.1-0.4c-0.4,0.2-0.6,0.7-0.4,1.1l1.3,2.9l-2.9,1.3 c-0.4,0.2-0.6,0.7-0.4,1.1c0.1,0.3,0.4,0.5,0.7,0.5c0.1,0,0.2,0,0.3-0.1l2.9-1.3l1.3,2.9c0.1,0.3,0.4,0.5,0.7,0.5 c0.1,0,0.2,0,0.3-0.1c0.4-0.2,0.6-0.7,0.4-1.1l-1.3-2.9l2.9-1.3c0.4-0.2,0.6-0.7,0.4-1.1C116.8,17.6,116.3,17.4,115.9,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M130.3,114.9c-0.2-0.4-0.7-0.6-1.1-0.4l-2.8,1.4l-1.4-2.8c-0.2-0.4-0.7-0.6-1.1-0.4c-0.4,0.2-0.6,0.7-0.4,1.1 l1.4,2.8l-2.8,1.4c-0.4,0.2-0.6,0.7-0.4,1.1c0.1,0.3,0.4,0.4,0.7,0.4c0.1,0,0.2,0,0.3-0.1l2.8-1.4l1.4,2.8c0.1,0.3,0.4,0.4,0.7,0.4 c0.1,0,0.2,0,0.3-0.1c0.4-0.2,0.6-0.7,0.4-1.1l-1.4-2.8l2.8-1.4C130.3,115.8,130.5,115.3,130.3,114.9z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M86,46.9c0.3,0.1,0.6,0.2,1,0.2s0.7-0.1,1-0.2l-1-1L86,46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M87.9,43.3l1.9,1.9c0.1-0.3,0.2-0.6,0.2-1c0-1.6-1.3-2.9-2.9-2.9s-2.9,1.3-2.9,2.9c0,0.3,0.1,0.7,0.2,1 l1.9-1.9C86.6,42.8,87.4,42.8,87.9,43.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M86,46.9l1-1l1,1c0.8-0.3,1.5-0.9,1.8-1.8l-1.9-1.9c-0.5-0.5-1.3-0.5-1.8,0l-1.9,1.9 C84.6,46,85.2,46.6,86,46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M107.7,58.5h-4.5L91.6,47c0.5-0.8,0.8-1.8,0.8-2.8c0-3-2.4-5.4-5.4-5.4s-5.4,2.4-5.4,5.4c0,1,0.3,2,0.8,2.8 L70.9,58.5h-4.5c-3.1,0-5.6,2.5-5.6,5.6v21.6c0,3.1,2.5,5.6,5.6,5.6h41.3c3.1,0,5.6-2.5,5.6-5.6V64.1 C113.2,61,110.7,58.5,107.7,58.5z M84.1,44.2c0-1.6,1.3-2.9,2.9-2.9s2.9,1.3,2.9,2.9c0,0.3-0.1,0.7-0.2,1c-0.3,0.8-0.9,1.5-1.8,1.8 c-0.3,0.1-0.6,0.2-1,0.2s-0.7-0.1-1-0.2c-0.8-0.3-1.5-0.9-1.8-1.8C84.2,44.8,84.1,44.5,84.1,44.2z M84.2,48.8 c0.8,0.5,1.8,0.8,2.8,0.8s2-0.3,2.8-0.8l9.8,9.8H74.4L84.2,48.8z M110.8,85.7c0,1.7-1.4,3.1-3.1,3.1H66.3c-1.7,0-3.1-1.4-3.1-3.1 V64.1c0-1.7,1.4-3.1,3.1-3.1h41.3c1.7,0,3.1,1.4,3.1,3.1V85.7z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M28,66.8c-3.2,0-5.8-2.6-5.8-5.8s2.6-5.8,5.8-5.8s5.8,2.6,5.8,5.8S31.2,66.8,28,66.8z M28,56.8 c-2.3,0-4.2,1.9-4.2,4.2s1.9,4.2,4.2,4.2s4.2-1.9,4.2-4.2S30.3,56.8,28,56.8z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65,119.8c-2.1,0-3.8-1.7-3.8-3.8s1.7-3.8,3.8-3.8s3.8,1.7,3.8,3.8S67.1,119.8,65,119.8z M65,113.8 c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2s2.2-1,2.2-2.2S66.2,113.8,65,113.8z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M51,7.8c-2.1,0-3.8-1.7-3.8-3.8s1.7-3.8,3.8-3.8s3.8,1.7,3.8,3.8S53.1,7.8,51,7.8z M51,1.8 c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2s2.2-1,2.2-2.2S52.2,1.8,51,1.8z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M130.1,13.8c-2.9,0-5.2-2.4-5.2-5.2s2.4-5.2,5.2-5.2s5.2,2.4,5.2,5.2S133,13.8,130.1,13.8z M130.1,4.8 c-2.1,0-3.8,1.7-3.8,3.8s1.7,3.8,3.8,3.8s3.8-1.7,3.8-3.8S132.2,4.8,130.1,4.8z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M137,54.8c-2.1,0-3.8-1.7-3.8-3.8s1.7-3.8,3.8-3.8s3.8,1.7,3.8,3.8S139.1,54.8,137,54.8z M137,48.8 c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2s2.2-1,2.2-2.2S138.2,48.8,137,48.8z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 178,
    cy: 85,
    r: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestoClose);
export default __webpack_public_path__ + "static/media/restoClose.9c3f0e79.svg";
export { ForwardRef as ReactComponent };